import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from './security/services/analytics.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private router: Router,
    private analyticsService: AnalyticsService,
    private location: Location,
  ) {
    const parts = this.location.path().split('?');
    const order = parts[1] ? new URLSearchParams(parts[1]).get('order') : null;
    this.analyticsService.init(
      !!order ? decodeURIComponent(order) : 'no_order',
    );
  }

  get showBrandings(): boolean {
    return !this.router.url.split('?')[0].endsWith('tools');
  }
}
